import Tab from "@/components/Tab";
import BatchReservationTab from "@/pages/Reservation/components/ReservationTab/BatchReservationTab";
import PlaceSearchTab from "@/pages/Reservation/components/ReservationTab/PlaceSearchTab";
import TimeSearchTab from "@/pages/Reservation/components/ReservationTab/TimeSearchTab";
import useUserStore from "@/store/userStore";

const ReservationTab = () => {
  const { roleId } = useUserStore();

  return (
    <Tab variant="enclosed" querystringKey="subTab">
      <Tab.Item label="장소로 검색">
        <PlaceSearchTab />
      </Tab.Item>
      <Tab.Item label="시간으로 검색">
        <TimeSearchTab />
      </Tab.Item>
      {roleId === "ADMIN" && (
        <Tab.Item label="일괄 예약">
          <BatchReservationTab />
        </Tab.Item>
      )}
    </Tab>
  );
};

export default ReservationTab;
